module.exports = {
  blank: 'Select a date...',
  headerFormat: 'ddd, MMM Do',
  todayLabel: {
    long: 'Today'
  },
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekStartsOn: 0
};


//////////////////
// WEBPACK FOOTER
// ../~/react-infinite-calendar/es/utils/defaultLocale.js
// module id = 2013
// module chunks = 1